import { moduleRequest } from '@/utils/request'

// 懒加载：避免模块初始化时因循环依赖导致 "Cannot access 'moduleRequest' before initialization"
let _request
const getRequest = () => {
	if (!_request) _request = moduleRequest(`/auth/c/`)
	return _request
}
/**
 * 登录接口管理
 *
 */
export default {
	// C端获取赣通码
	getGtmQrCode(data) {
		return getRequest()('getGtmQrCode', data, 'get')
	},
	// C端赣通码扫码是否授权成功检测
	checkGtmLogin(data) {
		return getRequest()('checkGtmLogin', data, 'get')
	},
	// C端获取图片验证码
	getPicCaptcha(data) {
		return getRequest()('getPicCaptcha', data, 'get')
	},
	// C端获取手机验证码
	getPhoneValidCode(data) {
		return getRequest()('getPhoneValidCode', data, 'get')
	},
	// C端账号密码登录
	login(data) {
		return getRequest()('v1/doLogin', data, 'post', false)
	},
	// C端手机验证码登录
	loginByPhone(data) {
		return getRequest()('v1/doLoginByPhone', data, 'post', false)
	},
	mpLoginByPhone(data) {
		return getRequest()('doMpLoginByPhone', data, 'post', false)
	},
	// 退出
	logout(data) {
		return getRequest()('doLogout', data, 'get')
	},
	// 获取用户信息
	getLoginUser(data) {
		return getRequest()('getLoginUser', data, 'get')
	},
	// 切换登录身份（个人/企业）
	loginIdentSwitch(data) {
		return getRequest()('v1/loginIdentSwitch', data, 'post')
	}
}
